module.exports = __webpack_public_path__ + "img/500g.4c848fa1.png";